// extracted by mini-css-extract-plugin
module.exports = {"text-regular":"14px","select":"LocationRadius-module--select--794147","label":"LocationRadius-module--label--a3dd87"};